import enGB from './catalogues/en-GB.js'
import es from './catalogues/es.js'
import frFR from './catalogues/fr-FR.js'
import itIT from './catalogues/it-IT.js'
import { PRIVANA_FALLBACK_LOCALE, normalizeLocale } from '../../shared/locales.mjs'

export const translationCatalogues = Object.freeze({ 'en-GB': enGB, es, 'fr-FR': frFR, 'it-IT': itIT })

function interpolate(message, values) {
  if (!values || typeof values !== 'object') return message
  return message.replace(/\{([A-Za-z0-9_]+)\}/g, (token, key) => Object.hasOwn(values, key) ? String(values[key]) : token)
}

function readKey(catalogue, key) {
  return key.split('.').reduce((value, part) => value?.[part], catalogue)
}

export function translate(key, locale = PRIVANA_FALLBACK_LOCALE, values = undefined) {
  const canonicalLocale = normalizeLocale(locale)
  const localized = readKey(translationCatalogues[canonicalLocale], key)
  if (typeof localized === 'string') return interpolate(localized, values)
  const fallback = readKey(translationCatalogues[PRIVANA_FALLBACK_LOCALE], key)
  if (typeof fallback === 'string') return interpolate(fallback, values)
  return `[missing:${key}]`
}
